const GA_MEASUREMENT_ID = "G-00000000";

export const initializeAnalytics = () => {
    const consent =
        localStorage.getItem("cookieConsent");

    if (consent !== "ACCEPT_ALL") {
        console.log("Google Analytics not allowed");
        return;
    }

    if (window.gtag) {
        return;
    }

    const script = document.createElement("script");

    script.async = true;
    script.src =
        `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;

    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];

    window.gtag = function () {
        window.dataLayer.push(arguments);
    };

    window.gtag("js", new Date());

    window.gtag(
        "config",
        GA_MEASUREMENT_ID,
        {
            send_page_view: false
        }
    );

    console.log("Google Analytics initialized");
};

export const trackLogin = () => {
    if (
        localStorage.getItem("cookieConsent")
        !== "ACCEPT_ALL"
    ) {
        return;
    }

    if (window.gtag) {
        window.gtag("event", "login");
    }
};

export const trackSignUp = () => {
    if (
        localStorage.getItem("cookieConsent")
        !== "ACCEPT_ALL"
    ) {
        return;
    }

    if (window.gtag) {
        window.gtag("event", "sign_up");
    }
};